import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './authReducer';
import notifications from './notificationsReducer';
import userState from './userStateReducer';
import wallet from './walletReducer';
import paymentCard from './paymentCardReducer';
import plans from './plansReducer';
import termsAndConditions from './termsAndConditionsReducer';
import bikes from './bikesReducer';
import zones from './zonesReducer';
import ride from './rideReducer';
import ridesHistory from './ridesHistoryReducer';
import operators from './operatorsReducer';
import cards from './cardsReducer';
import userCampaign from "./userCampaignStateReducer";
import { reducer as formReducer } from 'redux-form';
import appSettings from "./appSettingsReducer";

const rootReducer = history => combineReducers({
  router: connectRouter(history),
  auth,
  notifications,
  form: formReducer,
  userState,
  wallet,
  paymentCard,
  plans,
  termsAndConditions,
  bikes,
  zones,
  ride,
  ridesHistory,
  operators,
  cards,
  userCampaign,
  appSettings
});

export default rootReducer;
